import React from "react";
import { useParams } from "react-router-dom";
import FinancialsTabs from "./FinancialsTabs";

export default function Financials() {
  let params = useParams();
  const id = params.companyId;

  return (
    <>
      <FinancialsTabs id={id} />
    </>
  );
}
